module.exports = __webpack_public_path__ + "img/4.521bf3bb.png";